import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const PendingScreen = ({ onCancel }) => (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-950 text-white">
        <div className="text-center p-8 bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl max-w-sm animate-fade-in">
            <AlertTriangle size={48} className="mx-auto text-yellow-500 mb-4" />
            <h2 className="text-xl font-bold mb-2">Acesso Pendente</h2>
            <p className="text-sm text-slate-400 mb-6">Sua solicitação foi recebida e está aguardando a aprovação do setor de Gestão de Pessoas.</p>
            <button onClick={onCancel} className="text-blue-400 hover:text-blue-300 text-sm font-bold">Voltar para o Início</button>
        </div>
    </div>
);

export default PendingScreen;
